import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
    UploadFile,
    UploadFileUpdate,
    AssetUploadProperty, AssetUploadResponse,
    AssetUploadStart,
} from "./upload.model";
import {BehaviorSubject, delay, map, Observable} from "rxjs";
import {ApiResponse, getDataOrFail} from "../common/api-utils";
import {Asset, AssetWithProperties} from "../assets/asset.model";

@Injectable({
    providedIn: 'root'
})
export class UploadService {

    constructor(private http: HttpClient) {
    }

    startUpload(file: File): Observable<any> {
        let startData: AssetUploadStart = {
            filename: file.name,
            fileSize: file.size
        }
        return this.http.post<ApiResponse<any>>('/api/upload/init.json', startData).pipe(map(getDataOrFail));
    }

    uploadChunk(id: string, chunk: Blob, chunkIndex: number): Observable<AssetUploadResponse> {
        let formData = new FormData();
        formData.append('file', chunk);
        return this.http.post<ApiResponse<AssetUploadResponse>>(`/api/upload/${id}/addChunk/${chunkIndex}.json`, formData).pipe(map(getDataOrFail));
    }

    getUploadStatus(id: string): Observable<AssetUploadResponse> {
        return this.http.get<ApiResponse<AssetUploadResponse>>(`/api/upload/${id}.json`).pipe(map(getDataOrFail));
    }

    // Observable<HttpEvent<ApiResponse<string>>>
    // TODO deprecated - here for documentation purposes
    upload(file: File): Observable<string> {
       // console.log('uploading ' + file.name);
        const multipartReq = new FormData();
        multipartReq.append('file', file, file.name);
        /*return this.http.post<ApiResponse<string>>('/api/upload', multipartReq, {
            reportProgress: true,
            observe: 'events'
        });*/
        return new BehaviorSubject(Math.random() * 1000 + '').pipe(delay(1000));
    }

    getUploadProperties(): Observable<AssetUploadProperty[]> {
        return this.http.get<ApiResponse<AssetUploadProperty[]>>('/api/assetFields.json').pipe(map(getDataOrFail));
    }

    commitUpload(files: UploadFile[]): Observable<Asset[]> {
        return this.http.post<ApiResponse<any>>('/api/assets.json', files).pipe(map(getDataOrFail));
    }

    updateUpload(files: UploadFileUpdate[]): Observable<AssetWithProperties[]> {
        return this.http.put<ApiResponse<any>>('/api/assets.json', files).pipe(map(getDataOrFail));
    }

}
